<template>

<div>

  <el-form-item :label="element.label" :required="context.authentication.isRequired(element)">
    <template #label>
      <span :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
       <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
    </template>
    <el-input v-if="type==='fill'" placeholder="系统自动生成" readonly :model-value="data[element.id]" ></el-input>
    <div v-else-if="type==='detail'" class="design-detail">
      <span v-if="!element.clickEvent?.type"> {{ data[element.id] || "⠀" }}  </span>
      <span v-else style="color: #589EF8;text-decoration: underline;cursor: pointer" @click="handleClick"> {{ data[element.id] || "⠀" }}  </span>
    </div>
  </el-form-item>

  <app-form-view v-if="type==='detail' && element.clickEvent?.type==='lookFormByThisValue'" ref="appFormView" read-only></app-form-view>
</div>

</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import AppFormView from "@/components/app-form/app-form-view.vue";

export default {
  components: {AppFormView, FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: {},
      type: '',
    }
  },
  computed: {
    ...mapStores(useFlowStore,useFormStore)
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);
  },
  methods:{
    handleClick(){
      if(this.element?.clickEvent.type==='lookFormByThisValue'){
        let form = this.element.clickEvent.event.form;
        let column = this.element.clickEvent.event.column;

        this.formStore.findByConditions(form,[{
          fieldName:column,
          cs:'EQUALS',
          value:this.data[this.element.id]
        }]).then(res=>{
          if(res?.data.id){
            this.$refs.appFormView.call(form, res.data.id)
          }else{
            this.message('没有可预览的数据','warning')
          }

        })



      }

    }
  }
}

</script>

<style scoped lang="scss">

</style>